module.exports = __webpack_public_path__ + "img/three1Green.3936bc46.jpg";